/* eslint-disable */
import ajax from '../utils/ajaxHelper';
import { useCallback } from 'react';

const useClub = () => {
  const getClubCategories = useCallback(async (val) => {
    try {
      return await ajax.post(`community/get-club-categories`, val, {
        networkParams: { showLoader: false },
      });
    } catch (error) {
      return error;
    }
  }, []);

  const addClubDescForCommunity = useCallback(async (val) => {
    try {
      const values = {
        repId: val.repId,
        communityId: val.communityId,
        amenitiesDesc: val.amenitiesDesc,
        isAdminEntry: val.isAdminEntry,
      };
      return await ajax.post(`community/add-club-description`, values);
    } catch (error) {
      return error;
    }
  }, []);

  const addClubsConnectionsDescForCommunity = useCallback(async (val) => {
    try {
      const values = {
        repId: val.repId,
        communityId: val.communityId,
        clubsConnectionsDesc: val.clubsConnectionsDesc,
        isAdminEntry: val.isAdminEntry,
      };
      return await ajax.post(`community/add-clubs-connections-description`, values);
    } catch (error) {
      return error;
    }
  }, []);

  const addClub = useCallback(async (values) => {
    try {
      return await ajax.post(`community/add-club`, values);
    } catch (error) {
      return error;
    }
  }, []);

  const getClubById = useCallback(async (val) => {
    try {
      return await ajax.post(`community/get-club`, val, {
        networkParams: { showLoader: false },
      });
    } catch (error) {
      return error;
    }
  }, []);

  const getClubsPaginated = useCallback(async (val) => {
    try {
      return await ajax.post(`community/get-clubs-paginated`, val, {
        networkParams: { showLoader: false },
      });
    } catch (error) {
      return error;
    }
  }, []);

  const toggleClubFeatured = useCallback(async (val) => {
    try {
      const values = {
        clubId: val.clubId,
        featuredClub: val.featuredClub,
      };
      return await ajax.post(`community/toggle-club-featured`, values);
    } catch (error) {
      return error;
    }
  }, []);

  const deleteClub = useCallback(async (val) => {
    try {
      const values = {
        id: val.id,
      };
      return await ajax.post(`community/delete-club`, values);
    } catch (error) {
      return error;
    }
  }, []);

  return {
    getClubCategories,
    addClubDescForCommunity,
    addClubsConnectionsDescForCommunity,
    addClub,
    getClubById,
    getClubsPaginated,
    toggleClubFeatured,
    deleteClub,
  };
};

export default useClub;
